export default __webpack_public_path__ + "static/media/Logo.ac873fe6.svg";